import { PureComponent, Fragment } from 'react'
import { Breadcrumb } from 'antd'
import { withRouter } from 'react-router'
import {Link} from 'react-router-dom'
// import { t } from "@lingui/macro"
import iconMap from 'utils/iconMap'
import { queryAncestors } from 'utils'
import styles from './Bread.module.scss'
const { pathToRegexp } = require('path-to-regexp')

class Bread extends PureComponent<any> {
  generateBreadcrumbs = (paths) => {
    return paths.map((item, key) => {
      const content = item && (
        <Fragment>
          {item.icon && (
            <span style={{ marginRight: 4 }}>{iconMap[item.icon]}</span>
          )}
          {item.name}
        </Fragment>
      )

      return (
        item && (
          <Breadcrumb.Item key={key}>
            {paths.length - 1 !== key ? (
              <Link to={item.to || '#'}>{content}</Link>
            ) : (
              content
            )}
          </Breadcrumb.Item>
        )
      )
    })
  }
  render() {
    const { routeList, location } = this.props

    // Find a route that matches the pathname.
    const currentRoute = routeList.find(
      (_) => _.to && pathToRegexp(_.to).exec(location.pathname)
    )

    // Find the breadcrumb navigation of the current route match and all its ancestors.
    const paths = currentRoute
      ? queryAncestors(routeList, currentRoute, 'breadcrumbParentId').reverse()
      : [
          routeList[0],
          {
            id: 404,
            // name: t`Not Found`,
          },
        ]

    return (
      <Breadcrumb className={styles.bread}>
        {this.generateBreadcrumbs(paths)}
      </Breadcrumb>
    )
  }
}

export default withRouter(Bread)
